const config = {
  baseURL: process.env.REACT_APP_API_URL,
  env: process.env.REACT_APP_ENV,
};

export default config;
